<dacks-content (right-aside-close-click)="onRightAsideCloseClick()">

  <!-- TODO Texte auslagern -->
  <dacks-content-right-aside [ngClass]="{'hidden': !isLargeScreenWithRightAside}" slot="right-aside"
                             heading="Details" [open]="!!selectedProduct" size="extra-large">
    @if (!!selectedProduct) {
      <button mat-button class="mr-auto mb-6 mt-4" (click)="navigateToProductDetails(selectedProduct)">Ansicht vergrößern</button>
      @if (selectedProduct.documentUrl) {
        @if ((documentBuffer$ | async); as buffer) {
          <div class="w-full overflow-hidden">
            <doc-viewer
              class="relative w-full aspect-[2/3] z-0 doc-viewer-responsive-workaround"
              [src]="buffer"
              disableDocumentHeadline="true" disableAttachments="true" disableTableOfContents="true"
            ></doc-viewer>
          </div>
        } @else {
          @if (detailsContentError$ | async) {
            <ng-container *ngTemplateOutlet="errorDisplay; context: {
                    errorTitle: ('delivery-product-details.error_title' | translate),
                    errorText: ('delivery-product-details.error_document_viewer' | translate)}">
            </ng-container>
          } @else {
            <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
          }
        }
      } @else {
        <myupdates-html-viewer class="document-viewer-base document-viewer-product" [documentId]="selectedProduct.documentId">
        </myupdates-html-viewer>
        @if (detailsContentError$ | async) {
          <ng-container *ngTemplateOutlet="errorDisplay; context: {
                    errorTitle: ('delivery-product-details.error_title' | translate),
                    errorText: ('delivery-product-details.error_document_viewer' | translate)}">
          </ng-container>
        }
      }
    } @else {
      <!--   Dieser Zweig sollte nie aktiv werden -->
      <p>Wählen Sie ein Produkt aus, um weitere Details zu erhalten.</p>
    }

    <footer-spacing type="aside" />
  </dacks-content-right-aside>

  <div class="p-4 md:p-6">
    @if ((delivery$ | async); as delivery) {
      <div class="flex items-center gap-x-4">
        <!-- TODO sobald dacks-content-header auch mehrzeilig sein kann, die h1 damit umsetzen -->
        <h1 class="mu-heading-3 md:mu-heading-2 text-petrol-650">
          {{delivery.description.deliveryName}} am
          {{ delivery.description.deliveryDate | date:'dd.MM.yyyy' }} um {{ delivery.description.deliveryDate | date: 'HH:mm' }} Uhr
        </h1>
        <button mat-button class="hidden md:inline-flex ml-auto flex-shrink-0" aria-label="Teilen per Mail" color="light" (click)="shareByMail(delivery.description)">
          <mat-icon svgIcon="fi-teilen-20"></mat-icon>
          <span>{{ 'common.caption_share' | translate }}</span>
        </button>
        <button mat-fab class="md:hidden ml-auto flex-shrink-0" aria-label="Teilen per Mail" color="light" (click)="shareByMail(delivery.description)">
          <mat-icon svgIcon="fi-teilen-20"></mat-icon>
        </button>
      </div>
      @if (isLegalNoticeShown) {
        <div class="sm:pl-3.5 md:pl-6 text-sm md:text-base">{{'delivery.legal_notice' | translate}}</div>
      }
      @if (appState.isPersonalized$ | async) {
        <mat-slide-toggle class="mt-3.5" [checked]="appState.isPersonalDeliveryFilter"
                          (change)="changePersonalFilterState($event)">{{'filter-group.personalize_toggle' | translate}}</mat-slide-toggle>
      }
      <div class="md:hidden mt-4">
        <ng-container *ngTemplateOutlet="content; context: {delivery: delivery}"></ng-container>
      </div>
      <div class="hidden md:block">
        <mat-card class="mt-6">
          <ng-container *ngTemplateOutlet="content; context: {delivery: delivery}"></ng-container>
        </mat-card>
      </div>
    } @else {
      @if (errorInfo$ | async) {
        <myupdates-error-box class="error-box-dimmed-style"
                             [errorTitle]="'delivery-products.error_title' | translate"
                             [errorText]="'delivery-products.error_text' | translate">
        </myupdates-error-box>
      } @else {
        <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
      }
    }
  </div>

  <footer-spacing type="content" />
</dacks-content>

<ng-template #content let-delivery="delivery">
  <div>
    <div class="md:ml-6 mb-4 flex flex-row items-center">
      <mat-icon class="mr-2.5 mt-1 w-4 h-4" svgIcon="fi-information-20" aria-hidden="true"></mat-icon>
      <a href="{{'delivery-main.link_url_service_installation' | translate}}"
         target="_blank">{{'delivery-main.link_description_service_installation' | translate}}
      </a>
    </div>
    @if ((delivery?.groupedProducts?.size ?? -1) > 0) {
      <div>
        <div class="sm:pr-6 md:pl-6 pt-4">
          <dackl-accordion displayMode="light" multi>
            @for (group of delivery.productGroups; track group) {
              <dackl-expansion-panel headline="{{group}}"
                                     id="panel {{group}}" [expanded]="this.pageState.expandedPanelIds.indexOf('panel ' + group) >= 0"
                                     (opened)="onPanelOpened('panel ' + group)" (closed)="onPanelClosed('panel ' + group)">
                <myupdates-delivery-products-table-view
                  class="hidden md:block"
                  [products]="delivery.groupedProducts.get(group) ?? []"
                  [displayDeliveryBasesAndDataTransformation]="false"
                  [changeCategoriesVerticalOrientation]="false"
                  [selectedProduct]="selectedProduct"
                  [enableInlineSelection]="isLargeScreenWithRightAside"
                  (productSelected)="selectProduct($event)"
                ></myupdates-delivery-products-table-view>
                <div class="md:hidden mb-3 mt-2 flex flex-col gap-4 mx-1.5">
                  @for (product of delivery.groupedProducts.get(group) ?? []; track product) {
                    <div role="region" [attr.aria-label]="product.title">
                      <mat-card class="show-focus flex flex-row items-center p-4 relative" [tabindex]="(product.documentId || product.documentUrl) ? -1 : 0">
                        <div class="grow flex flex-col min-w-0">
                          <div class="mu-heading-5 mb-2">{{product.title}}</div>
                          <myupdates-change-categories class="pb-1" [changeCategories]="product.changeCategories"></myupdates-change-categories>
                        </div>
                        <div class="w-5">
                          @if (product.documentId || product.documentUrl) {
                            <a class="no-underline outline-none" [attr.aria-label]="'Mehr zu ' + product.title"
                               [routerLink]="['product', product.id]" id="md:a_{{product.id}}" tabindex="0">
                              <mat-icon svgIcon="sli-pfeil-rechts-20" aria-hidden="true"></mat-icon>
                              <span class="absolute inset-0 z-[2]"></span>
                            </a>
                          }
                        </div>
                      </mat-card>
                    </div>
                  }
                </div>
              </dackl-expansion-panel>
            }
          </dackl-accordion>
        </div>
      </div>
    } @else {
      <dackl-empty-state size="XS">
        @if (!(appState.isPersonalized$ | async)) {
          <div>
            <span  class="text-center font-semibold">
              {{ 'delivery-products.empty_product_list' | translate }}
            </span>
          </div>
        }
        @if ((appState.isPersonalized$ | async)) {
          <div>
            <div class="flex flex-col gap-6">
              <span  class="text-center font-semibold">
                {{ 'delivery-products.empty_product_list_personalized' | translate }}
              </span>
            </div>
          </div>
        }
      </dackl-empty-state>
    }
    <div class="flex flex-row items-start mt-10 md:pl-6">
      <mat-icon class="mr-2.5 mt-1 w-4 h-4" svgIcon="fi-information-20" aria-hidden="true"></mat-icon>
      <a href="{{'delivery-main.link_url_contract_info' | translate}}"
         target="_blank">{{'delivery-main.link_description_contract_info' | translate}}
      </a>
    </div>

  </div>
</ng-template>

<ng-template #errorDisplay let-errorTitle="errorTitle" let-errorText="errorText">
  <div class="flex items-center">
    <mat-icon class="w-7 h-7" svgIcon="fi-fehler-20"></mat-icon>
    <div class="mu-heading-2 pl-[0.8rem]">{{ errorTitle }}</div>
  </div>
  <div class="pt-4 pl-[2.8rem]">
    {{ errorText }}
  </div>
</ng-template>
